import { IconButton, Theme, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useIntl } from "react-intl";

const getStyles = (theme: Theme) => ({
  button: {
    color: theme.palette.primary.main,
  },
});

type BackLinkProps = {
  to: string;
};

export default function BackLink({ to }: BackLinkProps) {
  const { formatMessage: t } = useIntl();
  const navigate = useNavigate();

  const handleClick = () => {
    if (window.history?.length > 2) {
      navigate(-1);
    } else {
      navigate(to);
    }
  };

  const styles = getStyles(useTheme());
  return (
    <IconButton
      sx={styles.button}
      onClick={handleClick}
      aria-label={t({ id: "backToCourseDetails" })}
    >
      <ChevronLeftIcon />
    </IconButton>
  );
}
